"use client"

import Link from "next/link"
import dynamic from "next/dynamic"
import { DAPP_LINKS } from "@/lib/dapp-content"
import { useScramble } from "@/components/home/use-scramble"

const HeroDappReactorCore = dynamic(
  () => import("@/components/home/dapp-reactor-core").then((m) => ({ default: m.HeroDappReactorCore })),
  { ssr: false, loading: () => <div className="hero-reactor-loading" aria-hidden /> },
)

export function HeroSection() {
  const scrambledRef = useScramble("STONE_", 4200, 800)

  return (
    <div className="hero">
      <div className="hero-left">
        <div className="hero-eyebrow">/// TELEGRAM MINI APP · TON · TGE TARGET 19 SEP 2026</div>
        <p className="sr-only">
          Rivyu is a Telegram Mini App on The Open Network (TON) for mining, staking, referrals,
          and on-chain rewards. Token rules are published on-chain; TGE is targeted for
          19 September 2026, subject to completion of independent audit and legal-entity
          incorporation. Staking pools include tiers up to 60% APY.
        </p>
        <h1 aria-label="Set in stone">
          <span aria-hidden="true">
            SET IN
            <br />
            <span ref={scrambledRef} className="accent scrambled">
              STONE_
            </span>
          </span>
        </h1>
        <p className="hero-sub">
          Mine and stake RIVYU inside Telegram on TON—same wallet rails you already use.
          <br />
          TGE is targeted for <span className="em">19 September 2026</span> — subject to
          completion of the independent audit and legal-entity setup.
          <br />
          Read the contract and whitepaper first—open Telegram when it still checks out.
        </p>
        <div className="hero-cta-row">
          <a
            className="cta cta-motion"
            href={DAPP_LINKS.telegramBot}
            target="_blank"
            rel="noreferrer"
          >
            Open_in_Telegram //
          </a>
          <span className="cta-motion-wrap">
            <Link href="/whitepaper" className="cta cta-ghost">
              Read_Whitepaper //
            </Link>
          </span>
          <span className="cta-motion-wrap">
            <Link href="/learn" className="cta cta-ghost">
              Guides //
            </Link>
          </span>
        </div>
        <div className="hero-seal">
          <span>
            <span className="ok">●</span> TGE TARGET 19 SEP 2026
          </span>
          <span className="sep">//</span>
          <span>
            <span className="ok">●</span> FOUNDER_VEST 12mo
          </span>
          <span className="sep">//</span>
          <span>
            <span className="ok">●</span> 0% TEAM @ TGE
          </span>
        </div>
        <div className="hero-stats">
          <div>
            <span className="num">1B</span>
            Total_Supply
          </div>
          <div>
            <span className="num">60%</span>
            Max_Apy
          </div>
          <div>
            <span className="num">TEP-74</span>
            Standard
          </div>
          <div>
            <span className="num">12mo</span>
            Founder_Lock
          </div>
        </div>
      </div>

      <div className="hero-right">
        <div className="hero-reactor">
          <div className="hero-reactor-scale">
            <HeroDappReactorCore />
          </div>
        </div>
      </div>
    </div>
  )
}
